module.exports = __webpack_public_path__ + "img/nodejs.fb715d72.png";